import React from "react";
// import { Container } from '@material-ui/core';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

// import PostDetails from './components/PostDetails/PostDetails';
import ProjectDetails from './components/ProjectDetails/ProjectDetails';
import ProjectList from './components/ProjectList/ProjectList';
import ProjectForm from './components/ProjectForm/ProjectForm';
import Dashboard from './components/Dashboard/Dashboard';
import CoCreationForm from './components/CoCreationForm/CoCreationForm';
import Navbar from './components/Navbar/Navbar';
import Landing from './components/Landing/Landing';
import LandingEnt from './components/LandingEnt/LandingEnt';
// import Management from './components/Management/Management';
import Signup from './components/Auth/Signup/Signup';
import CompanySignup from './components/Auth/CompanySignup/CompanySignup';
import Login from './components/Auth/Login/Login';
import BetaForm from './components/Auth/BetaForm/BetaForm';
// import Home from "./components/Home/Home";
import useMedia from "use-media";
import background_mobile from './assets/background/background_mobile.svg';
import background from './assets/background/background.svg';
import useCommonStyles from './components/CommonStyle/commonStyle';
import Footer from './components/Footer/Footer';
import { useSelector } from 'react-redux';
import { store } from './index';
import useStyles from './styles';


const App = () => {
    type RootState = ReturnType<typeof store.getState>;
    const { loggedIn } = useSelector((state: RootState) => state.auth);
    const user = JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}');
    console.log(user);
    const classes = useStyles();

    const theme = createTheme({
        palette: {
            primary: {
                main: '#F3923D'
            },
            secondary: {
                main: '#86E6EC'
            }
        }
    });
    

    const isLarger500 = useMedia({ minWidth: "500px" });
    return (
        <BrowserRouter>
            <MuiThemeProvider theme={theme}>

                <div className={isLarger500 ? classes.appContainer : classes.appContainerMobile}>
                    <img src={isLarger500 ? background : background_mobile} alt="background" className={classes.backgroundImage} />
                    <Navbar />
                    <Switch>
                        <Route path="/" exact component={() => (<Redirect to="/startup" />)} />I
                        <Route path="/betaform" exact component={BetaForm} />I
                        <Route path='/googleform' component={() => {
                            window.location.href = 'https://forms.gle/a6AF2QLrMYXnVBPA8';
                            return null;
                        }} />
                        {/* <Route path="/startup" exact component={() => (JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}').result.name.length < 1 ? <Landing /> : <Redirect to="/startup/dashboard" />)} /> */}
                        <Route path="/startup" exact component={() => (!loggedIn ? <Landing /> : <Redirect to="/startup/dashboard" />)} />
                        {/* <Route path="/startup/login" exact component={() => (JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}').result.name.length < 1 ? <Login /> : <Redirect to="/startup/dashboard" />)} /> */}
                        <Route path="/startup/login" exact component={() => (!loggedIn ? <Login /> : <Redirect to="/startup/dashboard" />)} />
                        <Route path="/startup/signup" exact component={Signup} />I
                        {/* <Route path="/startup/dashboard" exact component={() => (JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}').result.name.length > 1 ? <Dashboard /> : <Redirect to="/startup" />)} /> */}
                        <Route path="/startup/dashboard" exact component={() => (loggedIn ? <Dashboard /> : <Redirect to="/startup" />)} />
                        {/* <Route path="/enterprise" exact component={() => (JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}').result.name.length < 1 ? <LandingEnt /> : <Redirect to="/startup/dashboard" />)} /> */}
                        <Route path="/enterprise" exact component={() => (!loggedIn ? <LandingEnt /> : <Redirect to="/startup/dashboard" />)} />
                        <Route path="/enterprise/signup" exact component={CompanySignup} />I
                        <Route path="/projects" exact component={ProjectList} />
                        {/* <Route path="/projects/form" exact component={() => (JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}').result.name.length > 1 ? <ProjectForm /> : <Redirect to="/startup" />)} /> */}
                        <Route path="/projects/form" exact component={() => (loggedIn ? <ProjectForm /> : <Redirect to="/startup" />)} />
                        {/* <Route path="/projects/co-creation-form" exact component={() => (JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}').result.name.length > 1 ? <CoCreationForm /> : <Redirect to="/startup" />)} /> */}
                        <Route path="/projects/co-creation-form" exact component={() => (loggedIn ? <CoCreationForm /> : <Redirect to="/startup" />)} />
                        <Route path="/projects/:id" exact component={ProjectDetails} />
                        {/* <Route path="/management" exact component={() => (<Management />)} /> */}
                        {/* <Route path="/posts" exact component={Home} />
                        <Route path="/posts/search" exact component={Home} />
                        <Route path="/posts/:id" exact component={PostDetails} /> */}
=                    </Switch>
                    <Footer />
                    {/* </Container> */}
                </div>
            </MuiThemeProvider>

        </BrowserRouter>

    );
}

export default App;